<template>
  <div class="wrapper position-relative">
    <div v-if="questions[currentQuestionIndex].isLast || currentPage == 'lastPage'">
      <top-three :lowestPrice="lowestPrice" :bestRating="bestRating" :bestAmazon="bestAmazon"
        :detailsContent="detailsContentLast" :explanations="finalExplanations" :shareable-link="shareableLink" @generate-share="generateShareLink" @copy-share="copyToClipboard" @reset="resetToStart">
        </top-three>
      <hr class="line-gap" />


      <h2>Weitere passende Fernseher zu deiner Auswahl</h2>

      <div class="container-lg underQuestion col-md-8 pt-4">
        <div class="ml-2">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-black"> Sortierung </span>
          <select id="sortSelect" v-model="selectedSortOption" @change="sortProducts" name="sortSelect"
            class="spanSelectField form-select form-select-lg mb-1">
            <option value="Keine">Preis/Leistung</option>
            <option value="videoGameVal">Gaming: Bewertung</option>
            <option value="videoGameVal_pred_pl">Gaming: Preis/Leistung</option>
            <option value="hdrVideoVal">Filme: Bewertung</option>
            <option value="hdrVideo_pred_pl">Filme: Preis/Leistung</option>
            <option value="sportsVal">Sport: Bewertung</option>
            <option value="sportsVal_pred_pl">Sport: Preis/Leistung</option>
            <option value="mixedVal">Vielseitigkeit: Bewertung</option>
            <option value="mixedUsageVal_pred_pl">Vielseitigkeit: Preis/Leistung</option>
            <option value="preisSortAuf">Preis aufsteigend</option>
            <option value="preisSortAb">Preis absteigend</option>
          </select>
        </div>
        <div class="row g-0">
          <div
            v-for="product in additionalProducts"
            :key="'additional-product-' + getProductId(product)"
            class="col-lg-4 mb-4"
          >
            <div class="card" :class="{ 'is-flipped': isFlipped(getProductId(product)) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel :product="product" />
                <div class="card-body">
                  <product-chart :product="product" />
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Diagonale</span>
                        </div>
                        <div>
                          <span v-if="!product.diagonale || isNaN(Number(product.diagonale))">
                            Keine Information
                          </span>
                          <span v-else>{{ product.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Display</span>
                        </div>
                        <div>
                          <span
                            v-if="product.paneltech === null || product.paneltech === undefined || product.paneltech === ''">Keine Information</span>
                          <span v-else>{{ product.paneltech }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.horizontalpixel }}x{{ product.vertikalpixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span
                            v-if="product.frequenzvertikal_merged === '0.00' || product.frequenzvertikal_merged === 0 || product.frequenzvertikal_merged == null || isNaN(Number(product.frequenzvertikal_merged))">
                            Keine Information
                          </span>
                          <span v-else>{{ product.frequenzvertikal_merged }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="datasheet-button" @click="flipCard(getProductId(product))">
                  <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ formatPreis(product.preisAmazonNeu) }}
                            €</span><br />
                        </div>
                        <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod
                    :product="product"
                    :instance-id="'product-' + getProductId(product)"
                  />
                  <button class="datasheet-button" @click="flipCard(getProductId(product))"><i
                      class="fa-solid fa-rotate-left icon-margin-right"></i>Zurück zur Übersicht</button>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-4" v-if="currentQuestionIndex > 0">
        <button class="datasheet-button" v-if="canLoadMoreProducts" @click="loadMoreProducts">
          Weitere Fernseher laden
        </button>
      </div>
    </div>
    <div class="text-center" v-else-if="questions[currentQuestionIndex].currentQuestionIndex === 0">
      <div class="container topCont" style="padding-top:0px;">
        <div class="headScroll" ref="headScroll" :key="currentQuestionIndex">
          <div class="row align-items center">
            <div class="col-md-6">
              <transition appear name="slide-fade" mode="out-in">
                <form class="multisteps_form position-relative" @submit.prevent="nextQuestion"
                  :key="currentQuestionIndex">
                  <div v-if="questions[currentQuestionIndex]" :key="questions[currentQuestionIndex]">
                    <div class="question-title mt-4">
                      <h2 class=" question-title text-center px-2 py-1">
                        {{ questions[currentQuestionIndex].question }}
                      </h2>
                    </div>
                  </div>
                  <div v-if="questions[currentQuestionIndex].isRadio" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex"
                      v-for="option in questions[currentQuestionIndex].options"
                      :key="'top-' + questions[currentQuestionIndex] + '-' + option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected:
                            questions[currentQuestionIndex].selectedOptionId ===
                            option.id,
                        },
                      ]">
                        <input class="form-check-input card-input" type="radio" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionId" @click="nextQuestionWithDelay" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isCheckbox" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex" v-for="option in questions[currentQuestionIndex].options"
                      :key="option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected: questions[
                            currentQuestionIndex
                          ].selectedOptionIds.includes(option.id),
                        },
                      ]">
                        <input class="" type="checkbox" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionIds" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isStepSlider">
                    <SliderSteps @update-slider="setSliderValue" />
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isSlider">
                    <div style="margin-top: 60px;">
                      <SliderComponent :minSize="currentMinSize" :maxSize="currentMaxSize"
                        @update-slider="updateSizes" />
                    </div>
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="back-button-wrapper" v-if="currentQuestionIndex > 0">
                      <button class="btn13" type="button" @click="goBack">Zurück</button>
                    </div>
                    <div class="back-button-wrapper"
                      v-if="questions[currentQuestionIndex].isCheckbox || questions[currentQuestionIndex].isSlider || questions[currentQuestionIndex].isStepSlider">
                      <button class="btn12-next" type="submit" :disabled="isNextButtonDisabled()">
                        Nächste Frage
                      </button>
                    </div>
                  </div>
                </form>
              </transition>
            </div>
            <div class="col-md-6" style="display: flex;
    align-items: center; margin-bottom: 20px;">
              <div>
                <div class="row">
                  <div class="col">
                    <blockquote class="speech-bubble" style="width: 80%; margin: 0 auto;">
                      <div class="container-infobox">
                        <p class="infoText" v-if="currentDescription" :key="currentDescription"
                          v-html="currentDescription">
                        </p>
                      </div>
                    </blockquote>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="position: relative;">
                    <img src="/wp-content/plugins/tv-berater/dingoTest.png" alt="Hund Bild" class="dingoPic">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            <div class="firstPage-info mb-4 text-start">
        <div class="card2 mt-4">
          <!-- Header mit Flexbox -->
          <div class="header-container">
            <h1 class="firstPage">Die TV-Kaufberatung</h1>
            <img class="logoMw" src="/wp-content/plugins/tv-berater/logo_small.png" width="160" height="80"
              alt="Monitorwelt Logo">
          </div>

          <!-- Einleitungstexte -->
          <div class="intro-text">
            <p>
              <strong>Wähle jetzt deinen primären Anwendungsbereich</strong> – auf dieser Basis stellen wir dir gezielte
              Folgefragen, um deine individuellen Bedürfnisse zu verstehen.
              Am Ende werden deine Angaben mit zahlreichen TV-Modellen abgeglichen – so findest du schnell und
              unkompliziert den idealen TV für dich. Während ein Verkäufer maximal 10-20 Modelle kennt, können online so viele Fernseher 
              wie möglich berücksichtigt werden.
            </p>

            <p>
              Egal ob für klassiches Fernsehen, Gaming, Sportübertragungen oder Film- und Kinoabende: Unsere
              <strong>interaktive TV-Kaufberatung</strong> analysiert deine Anforderungen und liefert konkrete
              Empfehlungen – personalisiert statt generische Tabellen!
            </p>

            <p>
              Am Ende bekommst du drei Vorschläge: den <strong>Günstigsten</strong>, den <strong>Leistungsstärksten für
                deinen Einsatz</strong> und den <strong>Preis-/Leistungssieger</strong>.
              Zusätzlich erhältst du weitere passende Modelle – exakt abgestimmt auf dein persönliches Nutzungsszenario, falls du lieber noch selbst erkunden magst.
            </p>

            <p>
              Beispiel: Du streamst gerne und oft Serien oder Filme, sitzt etwa 2,9 m entfernt und überlegst welche Größe 
              sich da am besten eignet. Lohnen sich dafür nun 120 Hertz und HDMI 2.1? Solche Überlegungen sind nur ein 
              Beispiel von vielen, die der Kaufberater berücksichtigt. Statt allgemeiner Empfehlungen bekommst du 
              Vorschläge, die möglichst zu deinem ganz eigenen Profil passen – individuell und mit Blick auf das beste Preis-Leistungs-Verhältnis. 
              Keine Lust auf Datenblätter wälzen? Hier sind Deine drei Kennzahlen-Modelle, die Du kennen solltest!
            </p>
          </div>
        </div>
        <top-three-example v-if="lowestPrice && bestRating && bestAmazon" :lowestPrice="lowestPrice"
          :bestRating="bestRating" :bestAmazon="bestAmazon" />
        <div class="card2 mt-4">
          <div class="header-container">
            <h1 class="firstPage">Erkennen deiner Anforderung und Nutzung</h1>
          </div>
          <div class="intro-text">
            <p>
              Ob für Filme im abgedunkelten Raum, Sport bei Tageslicht, Konsole/PC-Gaming, klassisches Rundfunk-Fernsehen, 
              mit Wandhalterung oder expplizit ein Android Betriebssystem: Jedes Nutzerprofil stellt ganz eigene Anforderungen 
              an die Spezifikationen des TVs. Genau hier setzt unsere Kaufberatung an: Die interaktive Sprechblase führt 
              dich zielsicher zur richtigen Wahl. Einfach, gezielt und individuell.
              Denn „TV“ ist nicht gleich TV: Brauchst du maximale Helligkeit gegen Spiegelungen? Top-Schwarz für Kino-Feeling? 
              4K120 mit VRR für Konsolen-Gaming? Die App erkennt solche Unterschiede 
              und gewichtet die Technik entsprechend – mit Blick auf eine Vielzahl an Verwendungsprofilen.

            </p>
          </div>
        </div>

        <MindMap></MindMap>
        <div class="card2 mt-4">
          <div class="intro-text">
            <p>
              Diese Nutzerprofile liefern einen strukturierten Überblick über typische Anwendungsfälle und deren spezifische Bedürfnisse. 
              Aber: Sie bleiben nur die Oberfläche und sind genersich anstatt persönlich zugeschnitten.
            </p>
          </div>
        </div>
        <div class="details-wrapper">
          <details v-for="(content, index) in detailsContent" :key="index">
            <summary class="no_select" @click="handleSummaryClick(index)">
              {{ content.summary }}
            </summary>
            <div class="detail-desc no_select">
              {{ content.description }}
            </div>
          </details>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container topCont" style="padding-top:0px;">
        <div class="headScroll" ref="headScroll">
          <div class="row align-items center">
            <div v-if="showProgress" class="col-12">
              <div class="progress-glass" :aria-valuenow="progressPercentage" aria-valuemin="0" aria-valuemax="100"
                role="progressbar">
                <span class="progress-glass__fill" :style="{ width: progressPercentage + '%' }">
                  <span class="sr-only">{{ progressPercentage }} %</span>
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <transition appear name="slide-fade" mode="out-in">
                <form class="multisteps_form position-relative" @submit.prevent="nextQuestion"
                  :key="currentQuestionIndex">
                  <div v-if="questions.length > 0">
                    <div v-if="questions[currentQuestionIndex]" :key="questions[currentQuestionIndex]">
                      <div class="question-title mt-4">
                        <h2 class="question-title text-center px-2 py-1">
                          {{ questions[currentQuestionIndex].question }}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div v-if="isLoader" class="overlay">
                    <div class="spinner-container">
                      <img src="/wp-content/plugins/tv-berater/logo_small.png" alt="Loading Icon"
                        class="rotating-image" />
                      <p class="loading-text">{{ loadingMessages[currentMessageIndex] }}</p>
                    </div>
                  </div>
                  <div v-if="questions[currentQuestionIndex].isRadio" class="rowX">

                    <div class="ite col-6 col-md-6 d-flex"
                      v-for="option in questions[currentQuestionIndex].options"
                      :key="currentQuestionIndex + '-' + option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected:
                            questions[currentQuestionIndex].selectedOptionId ===
                            option.id,
                        },
                      ]">
                        <input class="form-check-input card-input" type="radio" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionId" @click="nextQuestionWithDelay" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div v-else-if="questions[currentQuestionIndex].isCheckbox" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex" v-for="option in questions[currentQuestionIndex].options"
                      :key="option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected: questions[
                            currentQuestionIndex
                          ].selectedOptionIds.includes(option.id),
                        },
                      ]">
                        <input class="" type="checkbox" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionIds" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isStepSlider">
                    <SliderSteps :bereich="questions[currentQuestionIndex].bereich" @update-slider="setSliderValue" />
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isSlider">
                    <SliderComponent @update-slider="setSliderValues" />
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="back-button-wrapper" v-if="currentQuestionIndex > 0">
                      <button class="btn13-back" type="button" @click="goBack">Zurück</button>
                    </div>
                    <div class="back-button-wrapper"
                      v-if="questions[currentQuestionIndex].isCheckbox || questions[currentQuestionIndex].isSlider || questions[currentQuestionIndex].isStepSlider">
                      <button class="btn12-next" type="submit" :disabled="isNextButtonDisabled()">
                        Nächste Frage
                      </button>
                    </div>
                  </div>
                </form>
              </transition>
            </div>
            <div class="col-md-6" style="display: flex;
    align-items: center;">
              <div>
                <div class="row">
                  <div class="col">
                    <blockquote class="speech-bubble" style="width: 80%; margin: 0 auto;">
                      <div class="container-infobox typewriter">
                        <p class="infoText" v-if="currentDescription" :key="currentDescription"
                          v-html="currentDescription">
                        </p>
                      </div>
                    </blockquote>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="position: relative;">
                    <img src="/wp-content/plugins/tv-berater/dingoTest.png" alt="Hund Bild" class="dingoPic">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="questions[currentQuestionIndex].isLast"></div>
      <div v-else class="container-lg underQuestion col-md-8 pt-4">
        <div class="row">
          <div
            v-for="product in filteredProducts"
            :key="'product-' + getProductId(product)"
            class="col-lg-4 mb-4"
          >
            <div class="card" :class="{ 'is-flipped': isFlipped(getProductId(product)) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel :product="product" />
                <div class="card-body">
                  <product-chart :product="product" />
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Diagonale</span>
                        </div>
                        <div>
                          <span v-if="!product.diagonale || isNaN(Number(product.diagonale))">
                            Keine Information
                          </span>
                          <span v-else>{{ product.diagonale }} Zoll</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Display</span>
                        </div>
                        <div>
                          <span
                            v-if="product.paneltech === null || product.paneltech === undefined || product.paneltech === ''">Keine Information</span>
                          <span v-else>{{ product.paneltech }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span class="ml-2">{{ product.horizontalpixel }}x{{ product.vertikalpixel }}</span>
                        </div>
                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span class="ml-2"
                            v-if="product.frequenzvertikal_merged === '0.00' || product.frequenzvertikal_merged === 0 || product.frequenzvertikal_merged == null || isNaN(Number(product.frequenzvertikal_merged))">
                            Keine Information
                          </span>
                          <span v-else>{{ product.frequenzvertikal_merged }} Hz</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="datasheet-button" @click="flipCard(getProductId(product))"><i
                    class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ product.preisAmazonNeu }}€</span><br />
                        </div>
                        <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod
                    :product="product"
                    :instance-id="'product-' + getProductId(product)"
                  />
                  <button class="datasheet-button" @click="flipCard(getProductId(product))">Zurück zur Übersicht</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-4" v-if="currentQuestionIndex > 0">
        <button class="datasheet-button" v-if="canLoadMoreProducts" @click="loadMoreProducts">
          Weitere Fernseher laden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import SliderComponent from "/src/components/SliderComponent.vue";
import SliderSteps from "/src/components/SliderSteps.vue";
import ProductChart from "/src/components/ProductChart.vue";
import PicCarousel from "/src/components/PicCarousel.vue";
import DatenblattMod from "./components/DatenblattMod.vue";
import TopThreeDatenblattMod from "./components/TopThreeDatenblattMod";
import TopThree from "./components/TopThree.vue";
import TypeWriter from "./components/TypeWriter.vue";
import Feedback from "/src/components/Feedback.vue";
import TypeWriterEffect from "/src/components/TypeWriterEffect.vue";
import TopThreeExample from "./components/TopThreeExample.vue";
import MindMap from "./components/MindMap.vue"


export default {
  components: {
    SliderComponent,
    SliderSteps,
    ProductChart,
    PicCarousel,
    DatenblattMod,
    TopThree,
    TopThreeExample,
    MindMap,
    TypeWriter,
    TypeWriterEffect,
    TopThreeDatenblattMod,
    Feedback,
  },

  created() {
    this.updateDescription();
    const urlParams = new URLSearchParams(window.location.search);
    const sharedResults = urlParams.get('r');

    if (sharedResults) {
      try {

        let base64String = sharedResults
          .replace(/-/g, '+')
          .replace(/_/g, '/');


        while (base64String.length % 4) {
          base64String += '=';
        }

        const jsonString = atob(base64String);
        const parsedData = JSON.parse(jsonString);

        if (parsedData && Array.isArray(parsedData.aq) && Array.isArray(parsedData.so)) {
          this.answeredQuestions = parsedData.aq;
          this.selectedOptions = parsedData.so;

          this.fetchResults();
          this.collectExplanations();
        } else {

          console.error("Ungültige Datenstruktur im geteilten Link.");
          this.resetToStart();
        }
      } catch (e) {
        console.error("Fehler beim Verarbeiten des geteilten Links:", e);
        this.resetToStart();
      }
    } else {
      this.currentPage = 'start';
    }
  },


  methods: {
        //Progress Functions start
    getNextIndexAlongPath(questionIndex) {
      const q = this.questions[questionIndex];
      if (!q || q.isLast) return null;
      const answeredPos = this.answeredQuestions.indexOf(q.id);
      if (answeredPos !== -1) {
        const selectedValue = this.selectedOptions[answeredPos];
        const opt = q.options.find(o => o.id === selectedValue);
        return this.questions.findIndex(x => x.id === opt?.nextQuestionId);
      }

      return this.questions.findIndex(
        x => x.id === q.options[0].nextQuestionId
      );
    },

    countPathLength(questionIndex) {
      let count = 0;
      let idx = questionIndex;
      while (idx !== null && idx !== -1) {
        count++;
        const next = this.getNextIndexAlongPath(idx);
        idx = next;
      }
      return count;
    },

    updateProgress() {
      if (this.currentPage === 'lastPage') {
        this.progressPercentage = 100;
        return;
      }
      const answered = this.answeredQuestions.length;         // schon fix
      const remaining = this.countPathLength(this.currentQuestionIndex);
      const total = answered + remaining;

      this.progressPercentage = Math.round((answered / total) * 100);
    },
    //Progress Functions end

    updateUrlWithResults() {
      const dataToShare = {
        aq: this.answeredQuestions,
        so: this.selectedOptions,
      };

      const jsonString = JSON.stringify(dataToShare);
      const base64String = btoa(jsonString);
      const urlSafeBase64 = base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      const newUrl = `${window.location.pathname}?r=${urlSafeBase64}`;

      window.history.pushState({ page: 'results' }, 'Ergebnisse', newUrl);
    },

    resetToStart() {
      this.currentPage = 'start';
      this.flippedCards = [];
      this.currentQuestionIndex = 0;
      this.nextQuestionIndex = null;
      this.answeredQuestions = [];
      this.selectedOptions = [];
      this.products = [];
      this.loadedProducts = [];
      this.productsPerLoad = 9;
      this.loadedProductIndex = 9;
      this.isLoader = false;
      this.feedback = '';
      this.message = '';
      this.selectedSortOption = "Keine";
      this.finalExplanations = [];
      this.shareableLink = null;


      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      this.updateDescription();
      this.scrollToTop();
    },


    fetchResults() {
      if (this.answeredQuestions.length === 0) {
        console.error("Keine Antworten zum Abrufen der Ergebnisse vorhanden.");
        return;
      }

      this.currentPage = 'loading';

      $.ajax({
        url: "/wp-content/plugins/tv-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: this.answeredQuestions,
          selectedOptions: this.selectedOptions,
          limit: this.getApiLimit(),
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
          this.currentPage = 'lastPage';

          this.updateUrlWithResults();
          // --- NEUER TEIL ENDE ---
        },
        error: (error) => {
          console.error("Fehler beim Abrufen der Daten:", error);
          this.currentPage = 'start';
        },
      });
    },
    
    generateShareLink() {
      const dataToShare = {
        aq: this.answeredQuestions,
        so: this.selectedOptions,
      };

      const jsonString = JSON.stringify(dataToShare);
      const base64String = btoa(jsonString);
      const urlSafeBase64 = base64String
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');

      const baseUrl = window.location.origin + window.location.pathname;
      this.shareableLink = `${baseUrl}?r=${urlSafeBase64}`;
    },

    formatPreis(preis) {
      if (!preis) return '';
      return parseFloat(preis).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    sortProducts() {
      this.flippedCards = [];

      $.ajax({
        url: "/wp-content/plugins/tv-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: this.answeredQuestions,
          selectedOptions: this.selectedOptions,
          limit: this.getApiLimit(),
          sortOption: this.selectedSortOption,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
        },
        error: (error) => {
        },
      });
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    sendFeedback() {
      $.ajax({
        url: '/wp-content/plugins/tv-berater/get_feedback.php',
        method: 'POST',
        data: {
          feedback: this.feedback
        },
        dataType: 'json',
        success: (response) => {
          this.message = response.message;
          if (response.status === 'success') {
            this.feedback = '';
          }
        },
        error: (xhr, status, error) => {
          this.message = 'Es gab einen Fehler beim Senden des Feedbacks.';
        }
      });
    },

    updateDescription() {
      this.currentDescription = this.questions[this.currentQuestionIndex].tooltip;
      this.$nextTick(this.resetTypewriter);
    },
    getProductId(product) {
      return String(
        product?.id ??
        product?.asin ??
        product?.amazon_url ??
        product?.amazonNamenSuche ??
        ""
      );
    },

    getApiLimit() {
      return this.loadedProductIndex + 3;
    },

    flipCard(productId) {
      const id = String(productId);
      const cardIndex = this.flippedCards.indexOf(id);

      if (cardIndex === -1) {
        this.flippedCards.push(id);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },

    isFlipped(productId) {
      return this.flippedCards.includes(String(productId));
    },

    resetTypewriter() {
      const paragraphs = document.querySelectorAll(".typewriter > p");
      paragraphs.forEach(paragraph => paragraph.setAttribute("data-content", ""));
      this.startTypewriter();
    },
    startTypewriter() {
      const paragraphs = document.querySelectorAll(".typewriter > p");
      let currentLetter = 0;
      let currentParagraph = 0;
      const typeWriter = () => {
        if (currentParagraph >= paragraphs.length) return;
        const text = paragraphs[currentParagraph].textContent;

        if (currentLetter < text.length) {
          paragraphs[currentParagraph].setAttribute("data-content", text.slice(0, currentLetter + 1));
          currentLetter++;
        } else {
          currentParagraph++;
          currentLetter = 0;
        }

        setTimeout(typeWriter, currentLetter === text.length ? 500 : 25);
      };

      typeWriter();
    },
    loadMoreProducts() {
      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;
      this.loadedProductIndex += 9;
      $.ajax({
        url: "/wp-content/plugins/tv-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.getApiLimit(),
          sortOption: this.selectedSortOption,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
    },
    getWhiteBorder(img, pixelCount) {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imgData.data;
      const borders = {};

      function isWhiteLine(startIndex, endIndex, stride) {
        for (let i = startIndex; i <= endIndex; i += stride) {
          const r = pixels[i];
          const g = pixels[i + 1];
          const b = pixels[i + 2];
          const a = pixels[i + 3];
          if (!(r > 253 && g > 253 && b > 253 && a > 253)) {
            return false;
          }
        }
        return true;
      }
      if (
        isWhiteLine(
          pixelCount * canvas.width * 4,
          ((pixelCount + 1) * canvas.width - 1) * 4,
          4
        )
      ) {
        borders.top = true;
      }
      if (
        isWhiteLine(
          (canvas.height - pixelCount) * canvas.width * 4,
          (canvas.height - pixelCount + 1) * canvas.width * 4 - 1,
          4
        )
      ) {
        borders.bottom = true;
      }
      if (
        isWhiteLine(
          pixelCount * 4,
          (canvas.height - 1) * canvas.width * 4 + pixelCount * 4,
          canvas.width * 4
        )
      ) {
        borders.left = true;
      }
      if (
        isWhiteLine(
          (canvas.width - pixelCount) * 4,
          canvas.height * canvas.width * 4 +
          (canvas.width - pixelCount) * 4 -
          1,
          canvas.width * 4
        )
      ) {
        borders.right = true;
      }

      return borders;
    },

    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInRight animate__${delay}ms`;
    },

    initSlider() {
      if (!this.isSliderInitialized) {
        const sliderElement = this.$refs.slider77;
        noUiSlider.create(sliderElement, {
          start: [0],
          range: {
            min: 0,
            max: 100,
          },
        });
        this.isSliderInitialized = true;
      }
    },

    collectExplanations() {
      let explanations = [];

      this.answeredQuestions.forEach((questionId, index) => {
        const questionObj = this.questions.find(q => q.id === questionId);
        const selectedOptionId = this.selectedOptions[index];

        if (questionObj && !Array.isArray(selectedOptionId)) {
          // Radio
          const selectedOption = questionObj.options.find(opt => opt.id === selectedOptionId);
          if (selectedOption && selectedOption.explanation) {
            explanations.push(selectedOption.explanation);
          }
        } else if (questionObj && Array.isArray(selectedOptionId)) {
          // Checkbox(en) oder Slider
          selectedOptionId.forEach(optId => {
            const selectedOpt = questionObj.options.find(opt => opt.id === optId);
            if (selectedOpt && selectedOpt.explanation) {
              explanations.push(selectedOpt.explanation);
            }
          });
        }
      });

      // Jetzt das gesammelte Array in eine reaktive Variable schreiben
      this.finalExplanations = explanations;
    },

    nextQuestionWithDelay() {
      if (this.questions[this.currentQuestionIndex].needLoader) {
        this.isLoader = true;
        this.updateUrlWithResults();
        this.collectExplanations();
        this.startMessageRotation();
        setTimeout(() => {
          this.isLoader = false;
          clearInterval(this.messageInterval);
          this.currentMessageIndex = 0;
          this.nextQuestion();
          this.scrollToTop();

        }, 5000);
      }
      else {
        setTimeout(() => {

          this.nextQuestion();
          this.scrollToTop();

        }, 150);

      }
    },
    setSliderValues({ minSize, maxSize }) {
      this.minSize = minSize;
      this.maxSize = maxSize;
      this.questions[this.currentQuestionIndex].minSize = minSize;
      this.questions[this.currentQuestionIndex].maxSize = maxSize;
    },

    setSliderValue(value) {
      this.questions[this.currentQuestionIndex].selectedOptionId = value;
    },

    updateSizes(newSizes) {
      this.currentMinSize = this.minSize;
      this.currentMaxSize = this.maxSize;
    },

    nextQuestion() {
      this.loadedProductIndex = 9;
      this.flippedCards = [];
      let nextQuestionIndex = 0;
      let nextQuestionId = 0;
      if (this.currentQuestionIndex <= this.questions.length - 1) {

        if (this.questions[this.currentQuestionIndex].isSlider) {
          this.selectedOptions.push([
            Number(this.questions[this.currentQuestionIndex].minSize),
            Number(this.questions[this.currentQuestionIndex].maxSize)
          ]);
          nextQuestionIndex = 3;
          nextQuestionId = 3;
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
        }


        else if (this.questions[this.currentQuestionIndex].isStepSlider) {
          const sliderValue = this.questions[this.currentQuestionIndex].selectedOptionId
          this.selectedOptions.push(Number(sliderValue));
          nextQuestionId = this.questions[this.currentQuestionIndex].options[sliderValue].nextQuestionId;
          nextQuestionIndex = this.questions.findIndex(
            (question) => question.id === nextQuestionId
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
        }

        else if (this.questions[this.currentQuestionIndex].isCheckbox) {

          this.selectedOptions.push(

            this.questions[this.currentQuestionIndex].selectedOptionIds
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);

          if (this.currentQuestionIndex === 6) {
            nextQuestionIndex = 15;
          } else if (this.currentQuestionIndex === 6) {
            nextQuestionIndex = 15;
          }

        }
        else if (!(this.questions[this.currentQuestionIndex].isCheckbox)) {
          const selectedOption = this.questions[
            this.currentQuestionIndex
          ].options.find(
            (option) =>
              option.id ===
              this.questions[this.currentQuestionIndex].selectedOptionId
          );
          nextQuestionId = selectedOption.nextQuestionId;
          nextQuestionIndex = this.questions.findIndex(
            (question) => question.id === nextQuestionId
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
          this.selectedOptions.push(

            this.questions[this.currentQuestionIndex].selectedOptionId
          );

        }

        this.currentQuestionIndex = nextQuestionIndex;
        this.nextQuestionIndex = null;
        this.updateDescription();
      } else {

      }


      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;
      $.ajax({
        url: "/wp-content/plugins/tv-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.getApiLimit(),
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
        },
        error: (jqXHR, textStatus, errorThrown) => {

        },
      });
      this.updateProgress();
      this.scrollToTop();

    },

    getExampleData() {
      const answeredQuestionsExample = [0,8,2,5,3,6,9]
      const selectedOptionsExample = [4,1,6,[53.2,68.2],3,[9],1]
      const demoLimit = 15

      $.ajax({
        url: '/wp-content/plugins/tv-berater/apiNewData.php',
        method: 'GET',
        data: {
          answeredQuestions: answeredQuestionsExample,
          selectedOptions: selectedOptionsExample,
          limit: demoLimit
        },
        dataType: 'json',
        success: response => {
          this.lowestPrice = response.lowPriceProduct
          this.bestRating = response.bestGamingProduct
          this.bestAmazon = response.bestAmazonProduct
        },
        error: err => {
          console.error('Demo-Daten konnten nicht geladen werden:', err)
        }
      })
    },

    goBack() {
      this.loadedProductIndex = 9;
      this.flippedCards = [];
      if (this.answeredQuestions.length === 1) {
        const previousQuestionIndex = this.answeredQuestions.pop();
        const previousQuestionId = this.questions[previousQuestionIndex].id;
        const previousQuestionIndexInArray = this.questions.findIndex(
          (question) => question.id === previousQuestionId
        );
        if (
          previousQuestionIndexInArray !== -1 &&
          previousQuestionIndexInArray !== -2
        ) {
          this.currentQuestionIndex = previousQuestionIndexInArray;
          this.nextQuestionIndex = null;
          this.questions[previousQuestionIndex].selectedOptionId =
            this.selectedOptions.pop();
        }
      }

      else {
        const previousQuestionId = this.answeredQuestions.pop();
        const previousQuestionIndexInArray = this.questions.findIndex(
          (question) => question.id === previousQuestionId
        );

        if (
          previousQuestionIndexInArray !== -1 &&
          previousQuestionIndexInArray !== -2
        ) {
          this.currentQuestionIndex = previousQuestionIndexInArray;
          this.questions[previousQuestionIndexInArray].selectedOptionId =
            this.selectedOptions.pop();
        }
      }
      this.updateDescription();
      this.updateProgress();

      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;

      $.ajax({
        url: "/wp-content/plugins/tv-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.getApiLimit(),
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
    },
    isNextButtonDisabled() {

      const selectedOptionId =
        this.questions[this.currentQuestionIndex].selectedOptionId;
      const lowerValue = this.questions[this.currentQuestionIndex].lowerValue;
      //const upperValue = this.questions[this.currentQuestionIndex].upperValue;
      const isLowerValue = true;
      const isHigherValue = true;
      const isSlider = this.questions[this.currentQuestionIndex].isSlider;
      const isStepSlider = this.questions[this.currentQuestionIndex].isStepSlider;
      const isCheckbox = this.questions[this.currentQuestionIndex].isCheckbox;

      if (isSlider || isCheckbox || isStepSlider || isLowerValue || isHigherValue) {

        return false;
      } else {
        return !selectedOptionId;
      }
    },

    startMessageRotation() {
      this.messageInterval = setInterval(() => {
        this.currentMessageIndex =
          (this.currentMessageIndex + 1) % this.loadingMessages.length;
      }, 2500);
    }
  },

  mounted() {
    // Hier muss noch currentstate und exampledata hin
    if (this.currentPage === 'start') {

      this.getExampleData()
    }

    const paragraphs = document.querySelectorAll(".typewriter > *");

    let currentLetter = 0;
    let currentParagraph = 0;

    const typeWriter = () => {
      if (
        currentLetter <
        paragraphs[currentParagraph].textContent.length
      ) {
        paragraphs[currentParagraph].setAttribute(
          "data-content",
          paragraphs[currentParagraph].textContent.slice(
            0,
            currentLetter + 1
          )
        );
        currentLetter++;
      } else {
        currentParagraph++;
        currentLetter = 0;
      }

      if (currentParagraph === paragraphs.length) return;

      if (
        currentLetter ===
        paragraphs[currentParagraph].textContent.length
      )
        setTimeout(typeWriter, 500);
      else setTimeout(typeWriter, 25);
    };

    typeWriter();
    this.$nextTick(() => {
      const imgs = this.$el.querySelectorAll(".card-img-top");

      imgs.forEach((img) => {
        img.addEventListener("load", () => {
          const longerSide = Math.max(img.naturalWidth, img.naturalHeight);
          const pixelCount = Math.round(longerSide * 0.1);

          const borders = this.getWhiteBorder(img, pixelCount);
          const keys = Object.keys(borders);

          if (keys.length > 0) {
            if (keys.length === 4) {
              img.style.transform = "scale(1.10)";
            } else {
              let translateX = 0;
              let translateY = 0;
              if (borders.top && borders.bottom) {
              } else if (borders.top) {
                translateY = -4;
              } else if (borders.bottom) {
                translateY = 4;
              }
              if (borders.left && borders.right) {

              } else if (borders.left) {
                translateX = -4;
              } else if (borders.right) {
                translateX = 4;
              }

              img.style.transform = `translate(${translateX}%, ${translateY}%)`;
            }
          } else {
            img.style.transform = "scale(0.92)";
          }
        });

        if (img.complete) {
          img.dispatchEvent(new Event("load"));
        }
      });
    });



  },

  computed: {
    topThreeProductIds() {
      return new Set(
        [
          this.lowestPrice?.id,
          this.bestRating?.id,
          this.bestAmazon?.id,
        ]
          .filter(id => id !== undefined && id !== null && id !== "")
          .map(id => String(id))
      );
    },

    uniqueProducts() {
      const seen = new Set();

      return (this.products || []).filter(product => {
        const id = this.getProductId(product);

        if (!id || seen.has(id)) {
          return false;
        }

        seen.add(id);
        return true;
      });
    },

    filteredProducts() {
      return this.uniqueProducts.slice(0, this.loadedProductIndex);
    },

    additionalProducts() {
      return this.uniqueProducts
        .filter(product => !this.topThreeProductIds.has(this.getProductId(product)))
        .slice(0, this.loadedProductIndex);
    },

    canLoadMoreProducts() {
      const total = Number(this.totalProducts || 0);

      if (!total) {
        return false;
      }

      const isResultPage =
        this.currentPage === "lastPage" ||
        this.questions[this.currentQuestionIndex]?.isLast;

      if (isResultPage) {
        const visibleTotal = Math.max(0, total - this.topThreeProductIds.size);
        return this.loadedProductIndex < visibleTotal;
      }

      return this.loadedProductIndex < total;
    },
  },

  data() {
    return {
      currentPage: 'start',
      flippedCards: [],
      currentQuestionIndex: 0,
      nextQuestionIndex: null,
      answeredQuestions: [],
      selectedOptions: [],
      products: [],
      totalProducts: 0,
      lowestPrice: null,
      bestRating: null,
      bestAmazon: null,
      loadedProducts: [],
      productsPerLoad: 9,
      loadedProductIndex: 9,
      isLoader: false,
      feedback: '',
      message: '',
      selectedSortOption: "Keine",
      finalExplanations: [],
      shareableLink: null,
      showProgress: true,
      currentMinSize: 52,
      currentMaxSize: 68,
      minSize: 32,
      maxSize: 55,

      loadingMessages: [
        "Daten werden analysiert!",
        "Empfehlungen generieren..",
      ],
      currentMessageIndex: 0,
      messageInterval: null,
      detailsContentLast: [
        {
          summary: "Wieso diese zu dir passen?",
          description:
            "Geschafft! Hier sind deine Top-3 Fernseher-Empfehlungen nach Priorität: Der preisgünstigste Fernseher, um mindestens deine Anforderungen zu erfüllen, das leistungsstärkste Modell für deinen Anwendungsbereich und der Preis-Leistungs-Sieger. Gleichzeitig siehst du ihre Bewertungen im Bereich Gaming, Filme und Sportübertragungen. Diese können zwischen 1 und 10 liegen, währendem 10 absolute Spitzenklasse-Modelle repräsentiert. Weiter unten findest du weitere Modelle, die deine Kriterien erfüllen oder übertreffen – übersichtlich nach unserem berechneten Preis-Leistungs-Wert sortiert. Viel Spaß beim Entdecken!",
        },
      ],
      detailsContent: [
        {
          summary: "Warum ist der Fernseher-Berater unabhängig?",
          description:
            "Wir möchten dir die besten Fernseher empfehlen – ganz neutral und auf deine individuellen Bedürfnisse abgestimmt. Unsere Empfehlungen basieren primär auf neutralen Bewertungsmechanismen und technischer Leistung, ohne dabei bestimmte Marken oder Hersteller zu bevorzugen. Anders als Online-Shops, die oft gezielt Produkte hervorheben und gezielte Marketingstrategien für den Verkauf nutzen, sind wir unabhängig und konzentrieren uns darauf die genau für dich passenden Modelle zu identifizieren.",
        },
        {
          summary: "Wie funktioniert die Fernseher-Kaufberatung?",
          description:
            'Unsere TV-Kaufberatung führt dich durch durchschnittlich sechs Fragen, um deine persönlichen Präferenzen zu ermitteln. Dabei passen sich die Fragen dynamisch deinen Antworten an, sodass ein individueller Frageweg entsteht. Während der Beratung hilft dir unser intelligenter Dingo, technische Details zu verstehen und die passende Antwort zu finden. Unser Ziel ist es nicht, den leistungsstärksten Fernseher zu empfehlen, sondern das Modell, das optimal zu deinen Bedürfnissen passt. <br><p> Hinweise: <ul><li>Unsere Empfehlungen nutzen modernes Hybrid-Filtering: Eine Kombination aus manuellen, menschlichen Bewertungen und einer lernenden technischen Datenanalyse. So können präzisere und individuellere Vorschläge machen als herkömmliche Empfehlungen.</li><li>Bitte überprüfe gegebenenfalls die technischen Spezifikationen direkt auf den Seiten der Anbieter, da wir die Genauigkeit der Produktdaten nicht zu hundert Prozent garantieren können. </li></ul> Unsere Empfehlungen dienen als Orientierungshilfe – die endgültige Entscheidung liegt natürlich bei dir. </p>',
        },
        {
          summary: "Wieso wir keine Daten von dir speichern?",
          description:
            "Deine Daten werden von diesem Tool weder gespeichert noch weiterverarbeitet. Alle von dir eingegebenen Antworten bleiben nur während der Nutzung auf deinem Gerät und werden beim Schließen des Fernseher-Beraters vollständig gelöscht.",
        },
        {
          summary: "Wieso du keinerlei Aufpreis zahlst?",
          description:
            "Unser Service ist für dich komplett kostenlos, weil wir ausschließlich als Affiliate agieren. Das bedeutet, dass wir keinerlei Fernsehr direkt verkaufen, sondern auf externe Anbieter verlinken, bei denen die empfohlenen Produkte erhältlich sind. Wenn du über einen unserer Links einen Kauf tätigst, erhalten wir möglicherweise eine geringfügige Provision, ohne dass dir zusätzliche Kosten entstehen. Diese Provision ermöglicht es uns, dir weiterhin eine umfassende, unabhängige und neutrale Kaufberatung anzubieten, ohne dass du dafür bezahlen musst. Wichtig ist, möglichst die technischen Spezifikationen auf den Anbieterseiten zu überprüfen. Wir gewährleisten keine Richtigkeit der angegebenen Daten, aber sind stets bemüht diese so gut wie möglich abzudecken.",
        },
      ],

      openIndex: 0,

      questions: [
        {
          currentQuestionIndex: 0,
          id: 0,
          question: "Was ist dir bei der Nutzung deines neuen Fernsehers am wichtigsten?",
          tooltip: "Bitte wähle die Verwendung, die für dich persönlich die höchste Priorität darstellt. Das heißt nicht, dass er nur für diesen Zweck geeignet sein wird – die nächste Frage klärt, wie vielseitig der Fernseher sein soll. Unser System berücksichtigt zudem, wie sich die verschiedenen Nutzungsarten gegenseitig beeinflussen, um dir eine Empfehlung zu geben, die optimal auf dich zugeschnitten ist.",
          options: [
            {
              id: 2,
              label: "Klassisches Fernsehen",
              nextQuestionId: 11,
              iconPath: "/wp-content/plugins/tv-berater/tv_livetv.png",
              explanation: "Für klassisches Fernsehen muss die Technik nicht auf höchstem Niveau sein, das ist verworfenes Geld.",
            },
            {
              id: 3,
              label: "Gaming",
              nextQuestionId: 7,
              iconPath: "/wp-content/plugins/tv-berater/tvGaming.png",
              
            },
            {
              id: 4,
              label: "Filme, Serien und Streaming",
              nextQuestionId: 8,
              iconPath: "/wp-content/plugins/tv-berater/tvFilme.png",
              
            },
            {
              id: 5,
              label: "Sportübertragungen",
              nextQuestionId: 9,
              iconPath: "/wp-content/plugins/tv-berater/tvSport.png",
              
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 1,
          id: 1,
          question:
            'Möchtest du zwingend einen TV mit integrierten Smart-Funktionen?',
          tooltip: 'Überlege, ob ein TV mit integrierten Smart-Funktionen für dich wichtig ist, um direkt Apps wie Netflix oder YouTube nutzen zu können.',
          options: [
            { id: 1, label: "Ja, Smart-Funktionen sind wichtig für mich.", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsize_small.png"},
            { id: 2, label: "Nein, werden nicht gebraucht.", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsizesmall1.png" },
            { id: 3, label: "Kann, aber muss nicht.", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsizemiddle.png" },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 2,
          id: 2,
          question:
            'Welche TV-Größe ist die richtige für dich?',
          tooltip: 'Die Wahl der TV-Größe ist subjektiv. Wir empfehlen allerdings, die erste Option zu wählen: Basierend auf deinem Sitzabstand zum Fernseher können wir mittels Orientierung an THX- und SMPTE-Richtlinien die optimale Größe für dich berechnen. Mit der Größe des Fernsehers steigt allerdings auch der Preis.',
          options: [
            {
              id: 6, label: "Optimale Größe ermitteln", nextQuestionId: 5, iconPath: "/wp-content/plugins/tv-berater/tvcalcsize.png", 
            },
            {
              id: 5, label: "66 Zoll und größer", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsizeextralarge.png", explanation: "Je größer desto besser, nur ab 66 Zoll und mindestens 165cm Bilddiagonale."
            },
            {
              id: 4, label: "54-66 Zoll", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsizelarge.png", explanation: "Du willst Fernseher von 55 bis 65 Zoll, das ist die gängige Größe und bevorzugen die Meisten."
            },
            { id: 3, label: "42-55 Zoll", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsizemiddle.png", explanation: "Fernseher von 42 bis 55 Zoll, eine angemessene Größe." },
            { id: 2, label: "33-42 Zoll", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsizesmall1.png", explanation: "Fernseher von 32 bis 42 Zoll, eine gute Größe und noch relativ kompakt." },

            { id: 1, label: "Bis 32 Zoll", nextQuestionId: 3, iconPath: "/wp-content/plugins/tv-berater/tvsize_small.png", explanation: "Du willst es kompakt, heute eher seltener sind Fernseher bis etwa 32 Zoll." },

          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 3,
          id: 3,
          question: "Überlege, ob der Fernseher in der Nähe von großen Fenstern steht, durch die direktes Sonnenlicht auf den Bildschirm fällt.",
          tooltip: 'Direktes Sonnenlicht kann zu störenden Reflexionen auf dem Bildschirm führen und das Seherlebnis beeinträchtigen. Wähle die erste Option nur, wenn der Fernseher nahezu kontinuierlicher Sonneneinstrahlung mit hoher Intensität ausgesetzt ist. Einige Fernseher bieten spezielle Technologien wie Anti-Reflex-Beschichtungen oder eine höhere maximale Helligkeit, um diese Effekte abzumildern. Bei künstlicher Beleuchtung, wie durch Lampen oder gelegentlichem Sonnenlicht, können diese Spezifikationen weniger berücksichtigt werden. Ein gutes Mittel bietet die Auswahl von "Überwiegend künstliches Licht und gelegentliche Sonneneinstrahlung."',
          options: [
            {
              id: 1,
              label:
                "Sehr hohe Intensität von Sonneneinstrahlung direkt auf den Fernseher.",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/Sonnenlicht.png",
              explanation: "Bei starker Sonneneinstrahlung mindestens eine mögliche Helligkeit von 600 cd/m². Außerdem bevorzugt ein Mini-LED, gute Direct LED oder QD-OLED Display. Diese eigenen sich eher für hohe Sonnenintensität, da WOLED dort Schwächen hat."
            },
            {
              id: 2,
              label:
                "Überwiegend künstliches Licht und gelegentliche Sonneneinstrahlung.",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/KünstlichesLicht.png",
              explanation: "Bei gelegentlichem Licht, künstlich oder Sonneneinstrahlungen, sind OLEDs gut nutzbar. Wenn es doch etwas mehr ist, sollte ein Mini-LED, Direct-LED oder QD-OLED bevorzugt werden. Die allgmeine Performance jeder Display-Technologie wird bereits berücksichtigt."
            },
            {
              id: 3,
              label: "Der Fernseher ist selten bis kaum Lichtstrahlung ausgesetzt.",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/Dunkel.png",
              explanation: "Bei kaum bis keinen starken Lichtaussetzungen bieten OLEDs enorme Farbvielfalt, gefolgt von QD-OLED, Mini-LED und Direct-LED."
            },
            {
              id: 4,
              label: "Kann ich nicht genau sagen, wie die Lichtverhältnisse im Raum sind.",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/Vielleicht.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 4,
          id: 4,
          question: "Falls du Streaming-Plattformen nutzt, welche benötigst du zwingend auf deinem Fernseher?",
          tooltip: 'Diese Frage zielt darauf ab zu verstehen, welche Streaming-Plattformen für dich unverzichtbar sind, insbesondere wenn es um die Nutzung auf deinem Fernseher geht. So können deine Prioritäten bei der Mediennutzung besser erfasst werden. Hier hinzufügen dass es inklsuiver sein muss aber peripheriegeräte Xbox, PS oder Fire TV eben das ersetzen können.',
          options: [
            { id: 1, label: "Amazon Prime", nextQuestionId: 6, iconPath: "/wp-content/plugins/tv-berater/gegenNeu.png", },
            {
              id: 2,
              label: "Netflix",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/Nein.png",
              
            },
            {
              id: 3,
              label: "Disney+",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/Vielleicht.png",
              
            },
            {
              id: 4,
              label: "AppleTV+",
              nextQuestionId: 6,
              iconPath: "/wp-content/plugins/tv-berater/Vielleicht.png",
              
            }
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 5,
          id: 5,
          question: "Bitte gib deinen Abstand zum Fernseher an:",
          tooltip: "Damit wir die optimale Größe ermitteln können, benötigen wir den Abstand von deiner Position zum Fernseher. Anhand dessen können wir nach THX und SFMP den optimalen Größenbereich deines Fernsehers ermitteln.",
          options: [
            {
              id: 1,
              label: "eigene Zoll",
              nextQuestionId: 3,
              iconPath: "",

            },
          ],
          selectedOptionId: null,
          selectedOptionIds: [],
          isSlider: true,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 6,
          id: 6,
          question: "Sind weitere Features unabdingbar für deinen neuen Fernseher?",
          tooltip: 'Fast geschafft! Nur noch 2 Fragen. Weitere Features schränken die Auswahl stark ein, bitte markiere nur die Features auf die du keinesfalls verzichten kannst. Du kannst auch ohne Auswahl auf "Nächste Frage" gehen und dir die Features in den Eigenschaften anschauen. ',
          options: [
            {
              id: 1,
              label: "Aufnahme durch externe Festplatte",
              nextQuestionId: 15,
              iconPath: "/wp-content/plugins/tv-berater/tvrecording.png",
              isSelected: false,
            },
            {
              id: 2,
              label: "Apple AirPlay",
              nextQuestionId: 15,
              iconPath: "/wp-content/plugins/tv-berater/tvairplay.png",
              isSelected: false,
            },
            {
              id: 3,
              label: "Betriebssystem: Nur Google TV",
              nextQuestionId: 15,
              iconPath: "/wp-content/plugins/tv-berater/tvgoogletv.png",
              isSelected: false,
            },
            {
              id: 6,
              label: "Mit USB-Anschluss",
              nextQuestionId: 15,
              iconPath: "/wp-content/plugins/tv-berater/tvusb.png",
              isSelected: false,
            },

            /*{
              id: 7,
              label: "Ambilight",
              nextQuestionId: 16,
              iconPath: "/wp-content/plugins/tv-berater/Vielleicht.png",
            }, */

          ],
          selectedOptionIds: [9],
          isSlider: false,
          isStepSlider: false,
          isCheckbox: true,
          isRadio: false,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 7,
          id: 7,
          question: "Soll der Fernseher für anspruchsvolles Gaming optimiert sein oder eher vielseitig?",
          tooltip: 'Schätze, wie wichtig dir die Qualität von Gaming bei deinem Fernseher ist, um dessen Vielseitigkeitswert zu bestimmen. Je weiter du den Regler nach rechts schiebst, desto leistungsstärker ist er für Gaming. Wichtige Faktoren, neben der Beleuchtungstechnologie, sind Reaktionszeit, Bildfrequenz und Input Lag. Wenn du nur gelegentlich spielst, positioniere den Regler links. Beachte: Mehr Leistung bedeutet auch einen höheren Preis.',
          options: [
            {
              id: 1,
              label: "Eher vielseitig mit etwas Gaming",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 2,
              label: "Gaming ist eher wichtig",
              nextQuestionId: 10,
              iconPath: "",
              explanation: "Gaming ist dir eher wichtig, da ist HDMI 2.1 wichtig, damit aktuelle Konsolen damit zurecht kommen."
            },
            {
              id: 3,
              label: "Gaming hat höchste Priorität",
              nextQuestionId: 10,
              iconPath: "",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: true,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
          bereich: "gaming",
          sliderValue: 0,
        },
        {
          currentQuestionIndex: 8,
          id: 8,
          question: "Soll der Fernseher stark für Filme- und Serienstreaming optimiert sein oder eher vielseitig?",
          tooltip: 'Schätze, wie wichtig dir dir Qualität von Serien, Filme und Streaming bei deinem Fernseher ist, um dessen Vielseitigkeitswert zu bestimmen. Je weiter du den Regler nach rechts schiebst, desto leistungsstärker ist er für Serien, Filme und Streaming. Wichtige Faktoren, neben der Beleuchtungstechnologie, sind Schwarzwert, Farbraumabdeckung und die allgemeine Bilddarstellung. Wenn du nur gelegentlich Serien und Filme schaust, positioniere den Regler links. Beachte: Mehr Leistung bedeutet auch einen höheren Preis.',
          options: [
            {
              id: 1,
              label: "Eher vielseitig mit bisschen Serien",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 2,
              label: "Serien, Fime und Streaming sind eher wichtig",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 3,
              label: "Nahe Heimkino",
              nextQuestionId: 2,
              iconPath: "",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: true,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
          bereich: "streaming",
          sliderValue: 0,
        },
        {
          currentQuestionIndex: 9,
          id: 9,
          question: "Soll der Fernseher stark für Sportübertragungen optimiert sein oder eher vielseitig?",
          tooltip: 'Schätze, wie wichtig dir die Qualität von Sportübertragungen bei deinem Fernseher ist, um dessen Vielseitigkeitswert zu bestimmen. Je weiter du den Regler nach rechts schiebst, desto leistungsstärker ist er für Serien, Filme und Streaming. Wichtige Faktoren, neben der Beleuchtungstechnologie, sind Schwarzwert, Farbraumabdeckung und die allgemeine Bilddarstellung. Wenn du nur gelegentlich Serien und Filme schaust, positioniere den Regler links. Beachte: Mehr Leistung bedeutet auch einen höheren Preis.',
          options: [
            {
              id: 1,
              label: "Eher vielseitig mit gelegentlichem Sport",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 2,
              label: "Sportübertragungen sind eher wichtig",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 3,
              label: "Sportübertragungen haben hohe Priorität",
              nextQuestionId: 2,
              iconPath: "",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: true,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
          bereich: "sport",
          sliderValue: 0,
        },
        {
          currentQuestionIndex: 10,
          id: 10,
          question: "Welche Art von Gaming trifft auf dich zu?",
          tooltip: "Die Wahl des Fersnehers hängt davon ab, welche Art von Spielen du bevorzugst. Bei Shootern und wettbewerbsorientierten Spielen kommt es vor allem auf schnelle und unverzögerte Bilddarstellung an, während bei Story-Spielen die Bildqualität, Farbdarstellung und die Immersion in die Spielwelt entscheidend sind. Das eine schließt das andere natürlich nicht aus, allerdings lässt sich so der Fokus und die Stärken des Fernsehers optimieren.",
          options: [
            {
              id: 1,
              label:
                "Hauptsächliche Wettbewerbsorientierung und Player versus Player Gaming",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/tvGaming_PvP.png",
              explanation: "Für den Fokus auf PvP-Gaming sind Reaktionszeit und Frequenz entscheidend. Bevorzugt sind 144 Hertz, was das Maximum für Fernseher sind und dazu bevorzugt OLED, die mit die geringsten Reaktionszeiten und Input-Lag aufweisen."
            },
            {
              id: 2,
              label:
                "Bevorzugte Wettbewerbsorientierung mit gelegentlichen Story-Games",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/tvGaming_KompetitivUeberImmersion.png",
              explanation: "Der Fokus liegt hier klar auf kompetitivem Gaming. Eine hohe Bildwiederholfrequenz (mindestens 100, bevorzugt 144 Hertz) und geringe Reaktionszeiten sind daher sehr wichtig. Ein OLED-Fernseher ist eine exzellente Wahl, da er beides vereint: extrem schnelle Reaktionszeiten für den Wettbewerb und perfekte Schwarzwerte für die Darstellung von Story-Spielen."
            },
            {
              id: 3,
              label: "Bevorzugt Immersion/ Stoy-Games mit gelegentlicher Wettbewerbsorientierung",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/tvGaming_ImmersionUeberKompetitiv.png",
              explanation: "Bei bevorzugter Immersion, sind Bildqualität, Farbtreue und Kontrast entscheidend. Technologien wie OLED, QD-OLED oder Mini-LED bieten hier das beste Erlebnis. Für gelegentliche PvP-Runden sollte der Fernseher dennoch über einen Gaming-Modus mit geringem Input-Lag und möglichst 120 Hertz verfügen."
            },
            {
              id: 4,
              label:
                "Hauptsächlich Immersion in Spielen: Das Grafik-Erlebnis ist entscheidend",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/tvGaming_Immersion.png",
              explanation: "Bei voller Immersion zählt das visuelle Erlebnis. OLED-Fernseher sind aufgrund ihrer perfekten Schwarzwerte oft die erste Wahl. Alternativ bieten High-End QD-OLED- oder Mini-LED-Fernseher eine beeindruckende Helligkeit und Farbvielfalt. Wichtig ist eine gute HDR-Darstellung (Dolby Vision, HDR10+), um Spielwelten in ihrer vollen Pracht zu erleben."
            },
            /*{
              id: 5,
              label: "Durchschnittlich für wettbewerbsorientierte Spiele sowie angemessener Immersion",
              nextQuestionId: 6,
              iconPath: "storygraphic.png"
            },*/
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },

        {
          currentQuestionIndex: 11,
          id: 11,
          question: "Welchen Stellenwert hat die Leistungsfähigkeit im Bereich klassisches Fernsehen für dich?",
          tooltip: 'Dies hilft uns dabei, einzuschätzen, wie vielseitig der Fernseher sein sollte. Das bedeutet, er konzentriert sich natürlich auf die Verwendung des klassischen Fernsehens. Je vielseitiger der Fernseher ist – also je mehr zusätzliche Technologien und höhere Leistung er bietet –, desto höher fällt auch der Preis aus. Wenn du nur gelegentlich fernsehen möchtest, reicht ein einfaches Modell aus, das deine Anforderungen problemlos abdeckt. Je weiter du den Regel nach rechts verschiebst, desto leistungsstärker wird er für andere Bereiche.',
          options: [
            {
              id: 1,
              label: "Hauptzweck einfach TV gucken",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 2,
              label: "Sollte etwas vielsieitig sein",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 3,
              label: "Stärke in seiner Vielseitigkeit",
              nextQuestionId: 2,
              iconPath: "",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: true,
          isCheckbox: false,
          isRadio: false,
          isLast: false,
          needLoader: false,
          bereich: "klassisch",
          sliderValue: 0,
        },
        {
          currentQuestionIndex: 12,
          id: 12,
          question:
            "Wie möchtest du dein Live-TV empfangen?",
          tooltip: "Die Anforderungen an verschiedene Programme können variieren und je nach dem eignen sich bestimmte Fernseher besser und über welchen Weg sie die Bildprotokolle empfangen.",
          options: [
            {
              id: 1,
              label: "Telekom, Vodafone Box",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 2,
              label: "Fire TV Stick, Chromecast",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 3,
              label: "Antennenanschluss",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 4,
              label: "Kabelanschluss",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 5,
              label: "Satellitanschluss",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 6,
              label: "Integrierter Receiver benötigt",
              nextQuestionId: 2,
              iconPath: "",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 13,
          id: 13,
          question:
            "Wie viel Wert legst du auf die Darstellung der Farben?",
          tooltip: "Fernseher können durch Farbraumabdeckung, HDR und Hintergrundtechnologie Farben echter darstellen. Überlege wie wichtig dir die Darstellung möglichst intensiver Farb- und Schwarztöne ist.",
          options: [
            {
              id: 1,
              label: "Lieber günstig, Farbdarstellung ist zweitrangig. ",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 2,
              label: "Gute durchschnittliche Farbdarstellung.",
              nextQuestionId: 2,
              iconPath: "",
            },
            {
              id: 3,
              label: "Farben- und Schwarzdarstellung auf hohem Niveau.",
              nextQuestionId: 2,
              iconPath: "",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 14,
          id: 14,
          question:
            "Soll der Fernseher besonders energieeffizient sein?",
          tooltip: "Energieeffiziente Fernseher sind beliebt, da sie die Stromkosten senken. Die paneltech udn dessen Panel haben darauf erheblichen Einfluss.",
          options: [
            {
              id: 1,
              label: "Möglichst energieeffizient.",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/Ja.png",
            },
            {
              id: 2,
              label: "Ausgewogene energieeffizienz",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/Vielleicht.png",
            },
            {
              id: 3,
              label: "Leistung ist entscheidender als energieeffizienz.",
              nextQuestionId: 2,
              iconPath: "/wp-content/plugins/tv-berater/Nein.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: false,
        },
        {
          currentQuestionIndex: 15,
          id: 15,
          question:
            "Hast du vor deinen neuen Fernseher an die Wand zu hängen?",
          tooltip: "Falls du planst, den Fernseher an die Wand zu montieren, werden deine Empfehlungen Fernseher mit VESA-Vorrichtung enthalten. Indem du die Karten umdrehst, kannst du dir sogar dessen Maße anschauen.",
          options: [
            { id: 1, label: "Ja", nextQuestionId: 16, iconPath: "/wp-content/plugins/tv-berater/Ja.png", },
            {
              id: 2,
              label: "Nein",
              nextQuestionId: 16,
              iconPath: "/wp-content/plugins/tv-berater/Nein.png",
            },
          ],
          selectedOptionId: null,
          isSlider: false,
          isStepSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: false,
          needLoader: true,
        },
        {
          currentQuestionIndex: 16,
          id: 16,
          question: "",
          options: [
            { id: 1, label: "Günstigster Fernseher für deine Bedürfnisse." },
            { id: 2, label: "Leistungsstärkster Fernseher für deine Bedürfnisse." },
            { id: 3, label: "Bestes Preis-/ Leistungswert für deine Bedürfnisse." },
          ],
          selectedOptionId: null,
          isSlider: false,
          isCheckbox: false,
          isRadio: true,
          isLast: true,
          needLoader: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-image: url("");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display: flex;
}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}



.card-back {

  transform: rotateY(180deg);
  position: absolute;
}

.label-data-front {
  color: #999
}


#form .typewriter-container {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  width: 40%;
  text-align: justify;
}

.question-text {
  font-size: 18px;
  margin-top: 10px;
}



h1 {
  font-size: 3rem;
  margin-bottom: 2rem;
}

#form .container-infobox {
  text-align: left;

}

.typewriter>* {
  color: transparent;
  position: relative;
}

.icon-margin-right {
  margin-right: 8px;
}

.typewriter>*::after {
  content: attr(data-content);
  color: var(--font-color, black);
  position: absolute;
  left: 0;
  top: 0;
}

#form blockquote.speech-bubble {
  --arrow-w: 0.5em;
  --arrow-h: 1em;
  --bubble-corners: 5px;
  --w: 12em;
  --border-size: 1.5px;
  --text-color: black;
  --bubble-color: white;
  --border-color: #daab4f;
}

#form blockquote.speech-bubble {
  text-align: center;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 15px;
  font-weight: None;
  color: var(--text-color);
  background: var(--bubble-color);
  padding: 1.5rem 2.5rem;
  border-radius: var(--bubble-corners);
  box-shadow: 0 0 0 var(--border-size) var(--border-color);
  line-height: none;
  border: None;
}

#form blockquote.speech-bubble.round {
  --bubble-corners: 1em;
}

#form blockquote.speech-bubble.circle {
  --bubble-corners: 100%;
  padding: 2em;
}





#form blockquote.speech-bubble.pop {
  animation-name: pop;
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
}

@keyframes pop {
  0% {
    transform: scale(0.8);
  }

  80% {
    transform: scale(1.1);
  }

  90% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes float-up {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(calc(-1 * var(--arrow-h)));
  }
}

@keyframes float-left {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(calc(-1 * var(--arrow-h)));
  }
}

@keyframes float-right {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(var(--arrow-h));
  }
}

@keyframes float-down {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(var(--arrow-h));
  }
}

#form .container.topCont {
  padding-top: 0px;
  background-color: #f4f8ff;
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

}

@media (min-width: 1500px) {
  .container.topCont {
    max-width: 1230px;
    padding-top: 0px;
  }
}

#form .dingoPic {
  max-height: 250px;
  width: 20%;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: -40px;
  margin-right: 5px;
}

@media (max-width: 576px) {
  #form .dingoPic {
    max-height: 350px;
    width: 20%;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 5px;
    margin-bottom: 0;
  }

}

.question-title {
  font-family: HKGroteskPro, serif !important;
}

#form .btn12 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
}

#form .btn12-next {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  padding: .6em 1em .4em !important;
}

#form .btn13-back {
  background-color: #0d6efd30;
  border: 1px solid #222222 !important;
  padding: .6em 1em .4em !important;
}

.back-button-wrapper {
  margin-top: 10px;
  margin-left: 15px;
  margin-bottom: 20px;
}

.card2 {
    width: 60%;
    margin: 1rem auto;
}

@media (min-width: 1024px) {
  .firstPage-info {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
  }
}



@media (min-width: 1024px) {
  .underQuestion {}
}

h1.firstPage {
  font-size: 2rem;
  margin-top: 10px;
  margin-bottom: 0.5rem;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-fade-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.slide-fade-leave-from {
  opacity: 1;
  transform: translateX(0);
  width: 100%;
}

.slide-fade-leave-to {
  opacity: 0;
  display: block;
  transform: translateX(0);
}

.slide-fade-leave-active {
  transition: opacity 0.5s ease;
}

.infoText {
  text-align: left;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-container {
  text-align: center;
  color: white;
}

.rotating-image {
  width: 100px;
  animation: spin 2s linear infinite;
}

.loading-text {
  font-size: 1.5rem;
  margin-top: 1rem;
  animation: fadeInOutFast 2.5s ease-in-out infinite;
}


@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeInOutFast {

  0%,
  15% {
    opacity: 0;
  }

  25%,
  75% {
    opacity: 1;
  }

  85%,
  100% {
    opacity: 0;
  }
}

.line-gap {
  margin-top: 0px;
  margin-bottom: 25px;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: .25;
  height: 1px;
  background-color: #ccc;
  width: 100%;
}

h2.question-title {
  font-weight: 500 !important;
  font-size: 37px !important;
  font-family: HKGroteskPro, serif !important;
}


@media (max-width: 768px) {
  h2.question-title {
    font-size: 30px !important;
    font-family: HKGroteskPro, serif !important;
    font-weight: 500 !important;
  }
}


@media (max-width: 480px) {
  h2.question-title {
    font-size: 30px !important;
    font-family: HKGroteskPro, serif !important;
    font-weight: 500 !important;
  }
}

.sort-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  /* Anordnung untereinander */
  align-items: center;
  /* Links ausrichten */
}

.sort-container label {
  margin-bottom: 0.2em;
  /* Geringer Abstand zwischen Label und Select-Box */
  font-weight: bold;
  /* Optional, um das Label hervorzuheben */
}

.sort-container select {
  padding: 0.25em 0.5em;
  /* Optional, für ein etwas schöneres Select-Feld */
}

.spanField {
  background-color: #b9d1ff;
  border-radius: 10px 10px 0 0;
}

.spanSelectField {
  border-radius: 0 10px 10px 10px;
  border-width: 1px;
}

.form-select {
  width: auto;
}

/*Progress Bar Custom */
.row>.progress-glass {
  padding-left: 0;
  padding-right: 0;
}

.progress-glass {
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 1.5rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  --fill-start: rgb(255 255 255 / 0%);
  --fill-end: rgb(155 220 134 / 23%);
}

.progress-glass__fill {
  display: block;
  height: 100%;
  background: linear-gradient(90deg,
      var(--fill-start) 0%,
      var(--fill-end) 100%);
  border-radius: inherit;
  transition: width 0.4s ease;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

h1.firstPage {
  font-size: 2rem;
  margin-top: 10px;
  margin-bottom: 0.5rem;
}

.card2 {
  width: 60%;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 40em;
  margin: 0 auto 1rem;
}

.logoMw {
  display: block;
}

@media (max-width: 768px) {
  .logoMw {
    display: none;
  }
}

.intro-text {
  text-align: left;
  max-width: 40em;

  margin: 0 auto 1.5rem;
  line-height: 1.6;
}


.detail-desc {
  text-align: left;
  padding: 0.5rem 1rem;
}

.image-container {
  text-align: center;
  margin: 1.5rem 0;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .card2 {
    width: 100%;
    padding: 0 1rem;
  }

  .header-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .logoMw {
    margin-top: 1rem;
    align-self: flex-start;
  }

  .intro-text {
    max-width: 100%;
  }
}


@media (min-width: 768px) and (max-width: 1023px) {

  .container-md.underQuestion {
    max-width: 720px;
    padding: 1rem;
  }


  .row.g-0>.col-12 {}

  .card2 {
    width: 80%;
    margin: 1rem auto;
  }

  .firstPage-info {
    width: 80%;
    margin: 1.5rem auto;
  }

  h2.question-title {
    font-size: 32px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {

  .col-md-6 {
    flex: 0 0 auto;
    width: 80%;
  }
}

</style>